import React from 'react';

import InViewMonitor from 'react-inview-monitor';

import './styles.css';

// up
// left
// right

export default props => {
  return (
    <InViewMonitor
      classNameNotInView={`animation animation__appear-slide-${props.type}`}
      classNameInView={`animation animation__appear-slide-${props.type}--show`}
    >
      {props.children}
    </InViewMonitor>
  );
};
